<div class="toast toast-top toast-center items-center flex-col-reverse w-full z-[10000]">
  @for (toast of toasts; track $index) {
  <app-toaster class="w-full" [toast]="toast" (close)="removeToast(toast)" />
  }
</div>
